import React, {useEffect, useState} from 'react'
import {Form, Input, Button, message, Select, Col, Row} from 'antd'
import apiRequest from '../../../hooks/ApiRequest'
import {toast} from 'react-toastify'
const AddEditAssigneDocument = props => {
  const {form, documentID, onSuccess,visible} = props
  const {getFieldDecorator} = form
  const {Option} = Select
  const [loading, setLoading] = useState(false);
  const [masterDocument, setMasterDocument] = useState([]);
  const [productList,setProductList] = useState([]);
  const LoginInsurerId = JSON.parse(localStorage.getItem('insurerId'))
  useEffect(() => {
    if (documentID) {
      fetchDocument(documentID)
    } else {
        form.resetFields()
      }
    fetchMasterDocument()
  }, [visible, documentID])
  const fetchMasterDocument = async () => {
    try {
      const res = await apiRequest(process.env.REACT_APP_BASE_URL_DOCUMENT + `/DocumentMaster`,'GET',);
      const response = await apiRequest(process.env.REACT_APP_BASE_URL_ADMIN + '/Product/GetAllProducts','GET',);
      if (res.success) {
        setMasterDocument(res?.data?.data || []);
        setProductList(response?.data?.data || []);
      }
    } catch (err) {
      message.error('Failed to fetch document details')
    }
  }
  const fetchDocument = async id => {
    try {
      const res = await apiRequest( process.env.REACT_APP_BASE_URL_DOCUMENT + `/ModuleDocument/${id}`,
        'GET',
      )
      if (res.success) {
        const {moduleId, documentMasterId,productId} = res?.data?.data
        form.setFieldsValue({
          moduleId,
          documentMasterId,
          productId
        })
      }
    } catch (err) {
      message.error('Failed to fetch document details')
    }
  }

  const handlSubmit = e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return
      setLoading(true)
      debugger;
      const payload = {
        ...values,
        ...(documentID
          ? {
              id: documentID,
              modifiedBy: localStorage.getItem('username'),
              modifiedAt: new Date(),
              active: true,
            }
          : {
              createdBy: localStorage.getItem('username'),
              createdAt: new Date(),
            }),
      }
      payload.insurerId = LoginInsurerId;
      const url = documentID
        ? process.env.REACT_APP_BASE_URL_DOCUMENT +
          `/ModuleDocument/Update/${documentID}`
        : process.env.REACT_APP_BASE_URL_DOCUMENT + '/ModuleDocument'
      const method = 'POST'
      try {
        const response = await apiRequest(url, method, payload)
        if (response.success) {
          toast.success(
            documentID
              ? 'document updated successfully'
              : 'document added successfully',
          )
          if (onSuccess) onSuccess()
        } else {
          toast.error(response.error)
        }
      } catch (error) {
        toast.error('Something went wrong. Please try again.')
      } finally {
        setLoading(false)
      }
    })
  }
  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form layout="vertical" form={form} onSubmit={handlSubmit}>
          <Row gutter={16}>
          <Col md={12}>
              <Form.Item label="Select Product">
                {getFieldDecorator('productId', {
                  rules: [
                    {
                      required: true,
                      message: 'Please select Product',
                    },
                  ],
                })(
                  <Select placeholder="Select Product">
                    {productList?.map(item => (
                      <Option key={item?.productid} value={item?.productid}>
                        {item?.productname}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Select Module">
                {getFieldDecorator('moduleId', {
                  rules: [
                    {
                      required: true,
                      message: 'Please select module',
                    },
                  ],
                })(
                  <Select placeholder="Select module">
                    <Option key={102} value={102}>
                      Quotation
                    </Option>
                    <Option key={106} value={106}>
                      Policy
                    </Option>
                    <Option key={103} value={103}>
                      Claim
                    </Option>
                  </Select>,
                )}
              </Form.Item>
            </Col>
            <Col md={12}>
              <Form.Item label="Select Master Document">
                {getFieldDecorator('documentMasterId', {
                  rules: [
                    {
                      required: true,
                      message: 'Please select Master Document',
                    },
                  ],
                })(
                  <Select placeholder="Select Master Document">
                    {masterDocument?.map(item => (
                      <Option key={item?.id} value={item?.id}>
                        {item?.name}
                      </Option>
                    ))}
                  </Select>,
                )}
              </Form.Item>
            </Col>
          </Row>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className="btn-success">
            {documentID ? 'Update Document' : 'Submit Document'}
          </Button>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(AddEditAssigneDocument)
